const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
      obj[key] = formData.get(key);
    }
    return JSON.stringify(obj);
  };
  
  function fetchConfig(type = 'json', method = "POST") {
    return {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/${type}`,
        'Bypass-Tunnel-Reminder': "definitely"
      }
    };
  }
  
  function readCookie(name) {
    var nameEQ = name + "="
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length)
    }
    return null;
  }
  
  function scrollToTop () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  
  document.body.addEventListener("click", (event) => {
    if (event.target.matches("[type=reset]")) {
      event.preventDefault();
      const targetDetail = event.target.closest("details");
      if (targetDetail) {
        targetDetail.removeAttribute("open");
      }
    }
  });